import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import "./Navigation.css"
const NavigationBar = () => {
  return (
    <div style={{ backgroundColor: '#f8f9fa', fontFamily: 'Poppins, sans-serif' }}>
      <nav className="navbar navbar-expand-lg navbar-light">
        <div
          className="container-fluid"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "nowrap"
          }}
        >
          <div
            className="d-flex align-items-center flex-grow-1"
            style={{ minWidth: 0 }}
          >
            {/* Logo */}
            <Link
              to="/"
              style={{
                textDecoration: "none",
                flexShrink: 0
              }}
            >
              <img
                src={require("../../Assest/HDSILOGO.jpg")}
                alt="Logo"
                width="70"
                height="70"
                style={{
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #f8f9fa",
                  boxShadow: "0 0 10px rgba(0,0,0,0.1)"
                }}
              />
            </Link>

            {/* NGO Name */}
            <Link
              to="/"
              title="Human Development Society of India"
              style={{
                textDecoration: "none",
                color: "#1F2D5C",
                fontWeight: 700,
                fontSize: "1rem",
                lineHeight: "1.25",
                marginLeft: "12px",

                /* This is important */
                flex: 1,
                minWidth: 0,

                whiteSpace: "normal",
                wordBreak: "break-word"
              }}
            >
              Human Development Society of India
            </Link>
          </div>
          <button
            className="navbar-toggler ms-2"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo02"
            aria-controls="navbarTogglerDemo02"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{
              flexShrink: 0
            }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              {/* Using NavLink to manage active state */}
              <li className="nav-item">
                <NavLink className="nav-link" to="/" end>
                  HOME
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/projects">
                  PROJECTS
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/about">
                  ABOUT US
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/contact">
                  CONTACT US
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NavigationBar;
